import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import React, { useState, useEffect } from "react";
import { get } from '../utils/axios';


function Testimonial() {

  let [testimonial, setTestimonial] = useState([]);

  const getTestimonialData = () => {
    get(`/testimonial`)
      .then((res) => {
        if (res.success) {
          setTestimonial(res.data);
        }
      })
  };

  useEffect(() => {

    getTestimonialData();

  }, []);

  const arrowStyles = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 15px)',
    width: 40,
    height: 40,
    cursor: 'pointer',
    border: 'none',
    borderRadius: '50%',
    background: '#0E3B80',
    color: 'white',
    fontSize: '25px'
  };

  return (
    <section id="testmonialWrap" className="wow fadeInUp">
      <div className="container">
        <h2 className="mainHeading">What </h2>
        <h3 className="mainsubHeading">Our Students Says</h3>
        <div className="divider"></div>

        <Carousel autoPlay={true} infiniteLoop={true}
          showStatus={false} showIndicators={true}
          showThumbs={false} swipeable={true}
          emulateTouch={true} autoFocus={true} showArrows={true}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button type="button" onClick={onClickHandler} title={label} style={{ ...arrowStyles, left: 15 }}>
                {'<'}
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <button type="button" onClick={onClickHandler} title={label} style={{ ...arrowStyles, right: 15 }}>
                {'>'}
              </button>
            )
          }
        >

          {testimonial && testimonial.length > 0 && testimonial.map((item, index) =>
            <div className="item" key={index} >

              <div className="testitextwrap">
                <img src="images/quotes.png" alt="" className="quotesimg" style={{ display: 'block' }} />
                <span dangerouslySetInnerHTML={{ __html: item.description }} ></span>

              </div>

              <div className="testimage">
                {item.image && <img className='testimonial-img' src={item.image} alt="" />}
                <p className="testinauthorname">{item.name}</p>

              </div>

            </div>
          )}

        </Carousel>


      </div>
    </section>
  )
}

export default Testimonial;